import React from "react";
import { Box, Typography, Chip } from "@mui/material";
import { EXAMPLE_QUERIES } from "../../utils/askFlashDiceConstants";

export const EmptyState = ({ onExampleClick, isLoading = false }) => {
  const flattenedExamples = Object.values(EXAMPLE_QUERIES).flat();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        textAlign: "center",
        px: 2,
        py: 2.5,
        pb: 0,
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: 920,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 1.5,
        }}
      >
        <Typography
          sx={{
            color: "#1e293b",
            fontWeight: 700,
            fontSize: { xs: "1.5rem", sm: "1.75rem" },
            letterSpacing: "-0.02em",
          }}
        >
          Ask FlashDice
        </Typography>

        <Typography
          sx={{
            color: "#64748b",
            maxWidth: 600,
            fontSize: "0.9rem",
            lineHeight: 1.55,
            fontWeight: 400,
          }}
        >
          Ask anything about your warehouse and get instant SQL with clear
          explanations. Start with a suggested question or ask about products,
          sales, countries, and markets.
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: 1,
            maxWidth: 760,
          }}
        >
          {flattenedExamples.map((example, idx) => (
            <Chip
              key={`${example}-${idx}`}
              label={example}
              onClick={() => !isLoading && onExampleClick(example)}
              disabled={isLoading}
              variant="outlined"
              sx={{
                borderColor: "rgba(99, 102, 241, 0.35)",
                color: "#334155",
                backgroundColor: "rgba(255, 255, 255, 0.9)",
                fontSize: "0.78rem",
                fontWeight: 500,
                height: 30,
                "& .MuiChip-label": {
                  px: 1,
                },
                "&:hover": {
                  borderColor: "#3F49A7",
                  color: "#3F49A7",
                  backgroundColor: "rgba(99, 102, 241, 0.08)",
                },
                "&.Mui-disabled": {
                  opacity: 0.7,
                  borderColor: "rgba(99, 102, 241, 0.2)",
                },
              }}
            />
          ))}
        </Box>
      </Box>
    </Box>
  );
};

